import { TProduct, TProductById } from '../types/analytics';
import { IOffersDataState } from '../types/offersData';

export const prepareProducts = (offersData: IOffersDataState) => {
  const products: TProduct[] = [];
  const productsById: TProductById = {};

  offersData.newbuildings.forEach((newbuilding, index) => {
    const product: TProduct = {
      id: newbuilding.id,
      offerType: 'JK',
      position: index + 1,
    };

    products.push(product);
    productsById[newbuilding.id] = product;
  });

  return { products, productsById };
};
